module.exports = __webpack_public_path__ + "static/02-4345746c23c2d75557fe3ad209be3349.jpg";